import { Dialog } from '@progress/kendo-react-dialogs';
import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { createPortal } from 'react-dom';
import { useGlobalizationContext, useTranslation } from '@cs-cms/state-management';

export interface ICpsDialogProps {
  title: string | React.JSX.Element;
  message: string | React.JSX.Element;
  onConfirm: (confirmed: boolean, closeClicked?: boolean) => void;
  confirmButtonLabel?: string;
  discardButtonLabel?: string;
}

export const useCpsDialog = () => {
  const [dialogProps, setDialogProps] = React.useState<ICpsDialogProps | undefined>();
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  const showDialog = (props: ICpsDialogProps) => {
    setDialogProps(props);
  };

  const hideDialog = () => {
    setDialogProps(undefined);
  };

  const DialogComponent = dialogProps
    ? createPortal(
        <Dialog
          title={dialogProps.title}
          onClose={() => {
            dialogProps.onConfirm(false, true);
            hideDialog();
          }}
          className="cpsDialog"
        >
          <div className="formElementClassName">{dialogProps.message}</div>
          <div className="dialogFormButtons">
            <Button
              themeColor={'light'}
              onClick={() => {
                dialogProps.onConfirm(false);
                hideDialog();
              }}
              className="cpsDialogDiscardButton"
            >
              {dialogProps.discardButtonLabel || translate('custom.common.no')}
            </Button>
            <Button
              themeColor={'inverse'}
              onClick={() => {
                dialogProps.onConfirm(true);
                hideDialog();
              }}
              className="cpsDialogConfirmButton"
            >
              {dialogProps.confirmButtonLabel || translate('custom.common.yes')}
            </Button>
          </div>
        </Dialog>,
        document.body
      )
    : null;

  return {
    showDialog,
    DialogComponent
  };
};
